import { scaleCount, scaleRatio } from '../../../Shared/Services/count-up-value.util';
import { MonitoringTopRow } from '../Interfaces/monitoring-report.interface';
import { MonitoringTopDisplayRow } from '../Interfaces/monitoring-top-display-row.interface';
import { MonitoringRowLinkBuilder } from '../Types/monitoring-row-link-builder.type';

export function toTopDisplayRows<Row extends MonitoringTopRow>(
  rows: Row[],
  buildLink: MonitoringRowLinkBuilder<Row> | null,
  progress = 1,
): MonitoringTopDisplayRow[] {
  const peak = Math.max(0, ...rows.map((row) => row.count));

  return rows.map((row) => ({
    id: row.id,
    name: row.name,
    count: scaleCount(row.count, progress),
    percent: peak > 0 ? scaleRatio((row.count / peak) * 100, progress) : 0,
    link: buildLink ? buildLink(row) : null,
  }));
}
